<template>
  <div>
    <v-card>
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab>Comprobantes</v-tab>
        <v-tab>Presupuestos</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card-title>
            Historial de Ventas
            <v-spacer></v-spacer>
            <v-btn class="ma-2" color="green" fab small dark @click="_nuevo()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <Listado datos="/ventas" :encabezados="e_ventas" :acciones="a_ventas"></Listado>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-title>
            Presupuestos
            <v-spacer></v-spacer>
            <v-btn class="ma-2" color="green" fab small dark @click="_nuevo()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <Listado datos="/presupuestos" :encabezados="e_presupuestos" :acciones="a_presupuestos"></Listado>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import Listado from "@/components/Listado.vue";
export default {
  name: "Ventas_Listado",
  components: {
    Listado
  },
  data() {
    return {
      e_ventas: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta"
        },
        { text: "Cliente", value: "cliente.nombre" },
        { text: "Comprobante", value: "comprobante.tipo" },
        { text: "Subtotal", value: "subtotal" },
        { text: "Descuentos", value: "descuento" },
        { text: "Recargos", value: "recargo" },
        { text: "Total", value: "total" },
        {
          text: "Acciones",
          value: "acciones"
        }
      ],
      a_ventas: {
        ver: "/ventas/"
      },
      e_presupuestos: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta"
        },
        { text: "Cliente", value: "cliente.nombre" },
        { text: "Total", value: "total" },
        {
          text: "Acciones",
          value: "acciones"
        }
      ],
      a_presupuestos: {
        presupuesto: true
      },
      tab: 0
    };
  },
  methods: {
    _nuevo() {
      this.$router.push(`/ventas/nuevo`);
    }
  }
};
</script>
